/* __next_internal_client_entry_do_not_use__ ProductTileUpperContainer auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useProductTileContainerRef } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
export var ProductTileUpperContainer = function(param) {
    var children = param.children;
    var containerRef = useProductTileContainerRef();
    return /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        className: "relative",
        children: children
    });
};
